export default __webpack_public_path__ + "static/dolcevita-140a023467126b32f4f07c25074fb1ce.png";